import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const RadioInput = props => {
  const {
    text,
    options,
    field: { touched, error, ...field },
    disabled,
  } = props;

  delete field.initialValue;
  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });
  return (
    <div className={formGroupClass}>
      <div className="col-12 radio-col">
        <div className="radio-container">
          {options.map(option => (
            <label className="control control--radio" key={option}>
              <input
                type="radio"
                {...field}
                value={option}
                checked={field.value === option}
                disabled={disabled}
              />
              <div className="control__indicator" />
              <span className="wizard-text">{text[option]}</span>
            </label>
          ))}
        </div>
        {touched && error && <div className="help-block">{error}</div>}
      </div>
    </div>
  );
};

RadioInput.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  text: PropTypes.object.isRequired,
};

RadioInput.defaultProps = {
  options: ["yes", "no"],
};

export default RadioInput;



// WEBPACK FOOTER //
// ./src/components/RadioInput.js